import { __rest } from "tslib";
import { Drawer } from 'antd';
import classnames from 'classnames';
import React from 'react';
import style from './index.module.scss';
import { ReactComponent as CloseIcon } from './icon/close.svg';
import { apiHolder } from 'api';
export const tuple = (...args) => args;
const { isMac } = apiHolder.env;
const systemApi = apiHolder.api.getSystemApi();
const isWindows = systemApi.isElectron() && !isMac;
const SizeTypes = tuple('default', 'large');
const SiriusDrawer = props => {
    let { className, size = 'default', placement = 'right', width, height, closable } = props, restProps = __rest(props, ["className", "size", "placement", "width", "height", "closable"]);
    if (placement === 'left' || placement === 'right') {
        const sizeWidth = size === 'large' ? 888 : 504;
        width = width || sizeWidth;
    }
    else {
        const sizeHeight = size === 'large' ? 888 : 504;
        height = height || sizeHeight;
    }
    return (React.createElement(Drawer, Object.assign({ className: classnames(style.siriusDrawer, {
            [style.siriusDrawerWindows]: isWindows,
            [style.siriusDrawerClosable]: closable,
        }, className), closable: closable }, restProps, {
        placement,
        width,
        height,
        closeIcon: React.createElement(CloseIcon, null),
    }), props.children));
};
export default SiriusDrawer;
